export const HUMANS = [
  { id: 1, name: "Admin Geral", teamId: null, role: 'admin', avatar: 'AD' },
  { id: 2, name: "Maria Vendas", teamId: 'sales', role: 'agent', avatar: 'MV' }
];
